<template>
  <div class="example-wrapper">
    <div class="example-header">
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
        <div
        v-if="
          $route.name == 'add-contacts-to-existing-campaign-accounts' && context == 'AssociateContactToSelectedAccount' && 
          all_selected_rows.length != 0
        "
      >


            <vs-button
              @click="insertContactstoExistingAccountForCampaign"
              color="primary"
              >Add to Campaign</vs-button
            >
          </div>
          <div
            v-if="
              $route.name == 'new-selected_accounts-for-campaign' &&
              all_selected_rows.length != 0
            "
          >
            <vs-button
              @click="acceptMultipleContactstoAccountForCampaign"
              color="primary"
              >Add to Campaign</vs-button
            >
          </div>
          <div
            v-if="
              $route.name == 'add-new-accounts-contacts-to-campaign'  &&
              all_selected_rows.length != 0
            "
          >
            <vs-button @click="insertAccountToCampaign" color="primary"
              >Add to Campaign</vs-button
            >
          </div>
          <div
            v-if="
              $route.name ==
                'add-new-account-contacts-with-advanced-criteria'  &&
                all_selected_rows.length != 0
            " 
          >
            <vs-button
              @click="insertAccountContactsWithCriteria"
              color="primary"
              >Add to Campaign</vs-button
            >
          </div>

          <slot name="refresh-button"> </slot>
          
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <slot name="sort-button"> </slot>
          
          <!-- {{ context }} -->
          <vs-button  v-if="context == 'enrichAccountContactsGrid'"
          @click="onPageSizeChanged('accounts')"
          color="primary"
          class="ml-5"
          >Show All</vs-button>
          <vs-button  v-if="context == 'MatchedAccountForCampaign'"
            @click="getCampaignAccountsTotalRows()"
            color="primary"
            class="ml-5"
            >Show All</vs-button>
          <vs-button  v-if="context == 'MatchedContactForCampaign'"
            @click="getCampaignContactsTotalRows()"
            color="primary"
            class="ml-5"
            >Show All</vs-button>
          <vs-button  v-if="$route.name == 'add-new-account-contacts-with-advanced-criteria'"
            @click="onPageSizeChanged('accounts_contacts')"
            color="primary"
            class="ml-5"
            >Show All</vs-button>
            <vs-button  v-if="context == 'individaullySelectedGrid'"
            @click="onPageSizeChanged('campaign_accounts')"
            color="primary"
            class="ml-5"
            >Show All</vs-button>
            <vs-button  v-if="context == 'AssociateContactToSelectedAccount'"
            @click="onPageSizeChanged('contacts')"
            color="primary"
            class="ml-5"
            >Show All</vs-button>
          <!-- <select v-if="pagination" v-on:change="onPageSizeChanged($event)">
            <option value="10" selected="">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="All">All</option>
          </select> -->
          <div
            v-if="
              $route.name == 'remain-unmatched-accounts' ||
              $route.name == 'remain-unmatched-contacts'
            "
          >
            <vs-button class="ml-5" @click="exportTableData">Export</vs-button>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <ag-grid-vue
    :context="context"
    :paginationPageSizeSelector="paginationPageSizeSelector"
    :paginationPageSize="paginationPageSize"
      :detailCellRendererParams="detailCellRendererParams"
      :masterDetail="false"
      @goToDefaultViewDetails="goToDefaultViewDetails(data)"
      @goToDefaultOpportunititesViewDetails="goToDefaultOpportunititesViewDetails(data)"
      @goToEditDefaultView="goToEditDefaultView(data)"
      @goToEditDefaultOpportunititesView="goToEditDefaultOpportunititesView(data)"
      @emailOpportunityAlert="emailOpportunityAlert(data)"
      @editClientViewDetails="editClientViewDetails(data)"
      @createOpportunityDocsFile="createOpportunityDocsFile(data)"
      @viewClientUserAccountRecords="viewClientUserAccountRecords(account)"
      @viewClientUserContactRecords="viewClientUserContactRecords(contact)"
      @goToEditSalesDeveloperOpportunities="
        goToEditSalesDeveloperOpportunities(campaign)
      "
      @goToViewClientOpportunities="goToViewClientOpportunities(data)"
      @goToClientUserDefaultViews="goToClientUserDefaultViews(data)"
      @goToClientUserDefaultViewsOpportunities="goToClientUserDefaultViewsOpportunities(data)"
      @goToReviewQualityControlPage="goToReviewQualityControlPage(data)"
      @goToQualityControlAccounts="goToQualityControlAccounts(data)"
      @goToQualityControlContacts="goToQualityControlContacts(data)"
      @showStatusPopUp="showStatusPopUp(data)"
      @showTagPopUp="showTagPopUp(data)"
      @showSalesDeveloperAuditTrial="showSalesDeveloperAuditTrial"
      @showClientUserLive="showClientUserLive"
      @showClientUserInsights="showClientUserInsights"
      @dialNumber="dialNumber(data)"
      @showDialPopup="showDialPopup(data)"
      @onSDAccountFilterModified="onSDAccountFilterModified"
      @openPopulateDataPopUp="openPopulateDataPopUp(campaign)"
      @validatePopulateDataPopUp="validatePopulateDataPopUp(campaign)"
      @goToHistoricSDDashboard="goToHistoricSDDashboard(campaign)"
      @goToLiveSDDashboard="goToLiveSDDashboard(campaign)"
      @goToLiveSalesDeveloperDefaultViews="
        goToLiveSalesDeveloperDefaultViews(campaign)
      "
      @editSalesDeveloperAccount="editSalesDeveloperAccount(account)"
      @editSalesDeveloperContact="editSalesDeveloperContact(contact)"
      @showCampaignCascadedFields="showCampaignCascadedFields(campaign)"
      @updateCampaignCascadedFields="updateCampaignCascadedFields(campaign)"
      @deleteCampaignCascadedFields="deleteCampaignCascadedFields(campaign)"
      @showCampaignSelectedFields="showCampaignSelectedFields(campaign)"
      @associatedContactWithAccount="associatedContactWithAccount"
      @dropUnassociatedContacts="dropUnassociatedContacts"
      @rejectEnhancedAccounts="rejectEnhancedAccounts"
      @rejectRemainderAccounts="rejectRemainderAccounts"
      @acceptRemainderAccounts="acceptRemainderAccounts"
      @sendSelectionToActualPage="sendSelectionToActualPage"
      @viewContactpopup="viewContactpopup"
      @showContactsWithAccountID="showContactsWithAccountID(account_id)"
      @showContactsFieldsWithContactID="
        showContactsFieldsWithContactID(contact_id,account_id)
      "
      @onPaginationChangeContact="onPaginationChangeContact(data)"
      @editContactpopup="editContactpopup"
      @associateContactToSelectedAccountPopup="
        associateContactToSelectedAccountPopup
      "
      @addContactsPopUp="addContactsPopUp"
      @showCampaignStatusPopup="showCampaignStatusPopup(details)"
      :selected_account="selected_account"
      @showContactsPopUp="showContactsPopUp(account)"
      @associateMultipleContactToSelectedAccount="
        associateMultipleContactToSelectedAccount
      "
      @refreshAccountSelectionGrid="refreshAccountSelectionGrid"
      :dataSource="dataSource"
      :rowModelType="rowModelType"
      :serverSideStoreType="serverSideStoreType"
      :cacheBlockSize="cacheBlockSize"
      suppressSizeToFit="true"
      ref="dataGrid"
      :gridOptions="gridOptions"
      :accentedSort="true"
      class="ag-theme-quartz"
      :columnDefs="columnDefs"
      :getRowId="getRowId"
      domLayout="autoHeight"
      :rowSelection="rowSelection"
      colResizeDefault="shift"
      @grid-ready="onGridReady"
      @model-updated="onModelUpdated"
      @pagination-changed="onPaginationChanged"
      @cell-clicked="onCellClicked"
      @cell-double-clicked="onCellDoubleClicked"
      @cell-context-menu="onCellContextMenu"
      @cell-value-changed="onCellValueChanged"
      @cell-focused="onCellFocused"
      @filter-changed="onFilterApply($event)"
      @row-selected="onRowSelected($event)"
      @selection-changed="onSelectionChanged"
      @filter-modified="onFilterModified($event)"
      @virtual-row-removed="onVirtualRowRemoved"
      @rowClicked="onRowClicked"
      @column-everything-changed="onColumnEvent"
      @column-row-group-changed="onColumnEvent"
      @column-value-Changed="onColumnEvent"
      @column-moved="onColumnEvent"
      @column-visible="onColumnEvent"
      @column-group-Opened="onColumnEvent"
      @column-resized="onColumnEvent"
      @column-pinned-count-changed="onColumnEvent"
      :pagination="pagination"
      :suppressRowClickSelection="true"
      :sideBar="sideBar"
      :animateRows="true"
      :defaultColDef="{
        sortable: true,
        resizable: true,
        filter: true,
        // allow every column to be aggregated
        enableValue: false,
        // allow every column to be grouped
        enableRowGroup: false,
        // allow every column to be pivoted
        enablePivot: false
      }"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import 'ag-grid-enterprise'
import axios from '@/axios.js'
import defineAbilitiesFor from '@/config/abilities'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import CellRendererActions from '@/components/CellRendererActions.vue'
import CellRendererPopUpActions from '@/components/CellRendererPopUpActions.vue'
import CellRendererButtons from '@/components/CellRendererButtons.vue'
import DownloadExcelRendererActions from '@/components/DownloadExcelRendererActions.vue'
import "ag-grid-community/styles//ag-grid.css";
import "ag-grid-community/styles//ag-theme-quartz.css";


import { LicenseManager } from  'ag-grid-enterprise'
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-057721}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Elomark_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{elomarkportal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{elomarkportal}_need_to_be_licensed___{elomarkportal}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[0102]_MTc0MzcyMTIwMDAwMA==1137b2497a880d7e0eb4ecc86fb921b0")
export default {
  name: 'DataGrid',
  props: {
    columnDefs: {
      type: Array,
      default: ''
    },
    sideBar: {
      type: Object,
      default: () => {
        return {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              minWidth: 225,
              maxWidth: 225,
              width: 225,
              toolPanel: 'agColumnsToolPanel'
            },
            {
              id: 'filters',
              labelDefault: 'Filters',
              labelKey: 'filters',
              iconKey: 'filter',
              toolPanel: 'agFiltersToolPanel',
              minWidth: 180,
              maxWidth: 400,
              width: 250
            }
          ],
          position: 'right',
          defaultToolPanel: ''
        }
      }
    },
    rowSelection: {
      type: String,
      default: 'multiple'
    },
    context: {
      type: String,
      default: null
    },
    dataSource: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected_account: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pagination: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    table_total_rows: 0,
    all_selected_rows: [],
    rowModelType: null,
    serverSideStoreType: null,
    cacheBlockSize: null,
    // AgGrid
    gridApi: null,
    gridOptions: {},
    sideBar: {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          maxWidth: 225,
          width: 225,
          toolPanel: 'agColumnsToolPanel'
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250
        }
      ],
      position: 'right',
      defaultToolPanel: ''
    },
    context: null,
    abilities: null,
    sdAccountClickEventAccId: null,
    sdContactClickEventConId: null,
    detailCellRendererParams: null
  }),
  components: {
    CellRendererActions,
    CellRendererPopUpActions,
    AgGridVue,
    CellRendererButtons,
    DownloadExcelRendererActions
  },
  watch: {},
  methods: {
    goToDefaultViewDetails (data) {
      this.$emit('goToDefaultViewDetails', data)
    },
    goToEditDefaultView (data) {
      this.$emit('goToEditDefaultView', data)
    },
    goToDefaultOpportunititesViewDetails (data) {
      this.$emit('goToDefaultOpportunititesViewDetails', data)
    },
    goToEditDefaultOpportunititesView (data) {
      this.$emit('goToEditDefaultOpportunititesView', data)
    },
    emailOpportunityAlert (data) {
      this.$emit('emailOpportunityAlert', data)
    },
    editClientViewDetails (data) {
      this.$emit('editClientViewDetails', data)
    },
    createOpportunityDocsFile (data) {
      this.$emit('createOpportunityDocsFile', data)
    },
    goToReviewQualityControlPage (data) {
      this.$emit('goToReviewQualityControlPage', data)
    },
    goToQualityControlAccounts (data) {
      this.$emit('goToQualityControlAccounts', data)
    },
    goToClientUserDefaultViews (data) {
      this.$emit('goToClientUserDefaultViews', data)
    },
    goToClientUserDefaultViewsOpportunities (data) {
      this.$emit('goToClientUserDefaultViewsOpportunities', data)
    },
    goToQualityControlContacts (data) {
      this.$emit('goToQualityControlContacts', data)
    },
    showDialPopup (data) {
      // console.log("COLUMNSTATE" , this.gridApi.getColumnState())
      this.$emit('showDialPopup', data)
    },
    dialNumber (data) {
      this.$emit('dialNumber', data)
    },
    reloadData () {
      this.gridApi.refreshServerSide({purge : true})
      this.gridApi.setFilterModel(null)
      this.gridApi.$onFilterChanged()
      // alert("SDfsdf")
    },

    associatedContactWithAccount (account) {
      this.$emit('associatedContactWithAccount', account)
    },
    dropUnassociatedContacts (account) {
      this.$emit('dropUnassociatedContacts', account)
    },
    acceptRemainderAccounts (account) {
      this.$emit('acceptRemainderAccounts', account)
    },
    rejectRemainderAccounts (account) {
      this.$emit('rejectRemainderAccounts', account)
    },
    rejectEnhancedAccounts (account) {
      this.$emit('rejectEnhancedAccounts', account)
    },
    exportTableData () {
      this.gridApi.exportDataAsExcel()
    },
    showContactsPopUp (account) {
      this.$emit('showContactsPopUp', account)
    },
    showCampaignSelectedFields (account) {
      this.$emit('showCampaignSelectedFields', account)
    },
    showCampaignCascadedFields (account) {
      this.$emit('showCampaignCascadedFields', account)
    },
    openPopulateDataPopUp (account) {
      this.$emit('openPopulateDataPopUp', account)
    },
    validatePopulateDataPopUp (account) {
      this.$emit('validatePopulateDataPopUp', account)
    },
    goToEditSalesDeveloperOpportunities (account) {
      this.$emit('goToEditSalesDeveloperOpportunities', account)
    },
    goToViewClientOpportunities (opp) {
      this.$emit('goToViewClientOpportunities', opp)
    },
    showTagPopUp (account) {
      this.$emit('showTagPopUp', account)
    },
    showStatusPopUp (data) {
      this.$emit('showStatusPopUp', data)
    },
    goToHistoricSDDashboard (campaign) {
      this.$emit('goToHistoricSDDashboard', campaign)
    },
    goToLiveSDDashboard (campaign) {
      this.$emit('goToLiveSDDashboard', campaign)
    },
    goToLiveSalesDeveloperDefaultViews (campaign) {
      this.$emit('goToLiveSalesDeveloperDefaultViews', campaign)
    },
    editSalesDeveloperAccount (account) {
      this.$emit('editSalesDeveloperAccount', account)
    },
    editSalesDeveloperContact (contact) {
      this.$emit('editSalesDeveloperContact', contact)
    },
    viewClientUserAccountRecords (account) {
      this.$emit('viewClientUserAccountRecords', account)
    },
    viewClientUserContactRecords (contact) {
      this.$emit('viewClientUserContactRecords', contact)
    },
    showSalesDeveloperAuditTrial (contact) {
      this.$emit('showSalesDeveloperAuditTrial', contact)
    },
    showClientUserLive (contact) {
      this.$emit('showClientUserLive', contact)
    },
    showClientUserInsights (data) {
      this.$emit('showClientUserInsights', data)
    },
    updateCampaignCascadedFields (account) {
      this.$emit('updateCampaignCascadedFields', account)
    },
    deleteCampaignCascadedFields (account) {
      this.$emit('deleteCampaignCascadedFields', account)
    },

    updateCampaignSelectedFields (account) {
      this.$emit('updateCampaignSelectedFields', account)
    },
    DownloadCampaignSelectedFields (account) {
      this.$emit('DownloadCampaignSelectedFields', account)
    },
    viewContactpopup (contact) {
      this.$emit('viewContactpopup', contact)
    },
    showContactsFieldsWithContactID (contact,account_id) {
      this.$emit('showContactsFieldsWithContactID', contact,account_id)
    },
    editContactpopup (contact) {
      this.$emit('editContactpopup', contact)
    },
    associateContactToSelectedAccountPopup (account) {
      this.$emit('associateContactToSelectedAccountPopup', account)
    },
    associateMultipleContactToSelectedAccount (account) {
      this.$emit('associateMultipleContactToSelectedAccount', account)
    },
    addContactsPopUp (account) {
      this.$emit('addContactsPopUp', account)
    },
    refreshAccountSelectionGrid () {
      this.$emit('refreshAccountSelectionGrid')
    },
    showCampaignStatusPopup (details) {
      this.$emit('showCampaignStatusPopup', details)
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {
          type: 'equals',
          filter: val
        }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    onPageSizeChanged (table_name) {


      
       




      // self.gridApi.setGridOption('paginationPageSize', 25000)
      this.getTotalRowsOfTable(table_name)
    },
    onModelUpdated () {
      // console.log("onModelUpdated");
    },


  onPaginationChanged (params) {
let self = this


      if (params.context != 'AssociateContactToSelectedAccount') {
            this.$emit('onPaginationChangeContact', params)

    this.gridApi.deselectAll()


self.all_selected_rows.forEach(function (row) {
  self.gridApi.forEachNode(function (node) {
   if (typeof (node.data) != 'undefined'){




      if (typeof(node.data.contact_id) != 'undefined' ){

            if (node.data.contact_id == row.contact_id) {
            node.setSelected(true)
          }

           }
           else{

            if (node.data.account_id == row.account_id) {
            node.setSelected(true)
          }

           }

   }
    
  
  })
})
      }





  },
    onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      params.api.setGridOption('serverSideDatasource', this.dataSource)


      this.gridApi.setServerSideSelectionState({
    selectAll: false,
    toggledNodes: [],
});

      // params.api.setGridOption('suppressPropertyNamesCheck', true)

      // params.api.setServerSideDatasource(this.dataSource)
    },
    onCellClicked (event) {
      if ((event.type = 'cellClicked')) {
        event.node.hightlight = '1'
        event.node.setSelected(true)

        if (
          event.context == 'AccountDataSourceForClientView'
          // event.colDef.field == "head_office_country"
        ) {
          let account_id = event.data.account_id

          if (event.node.highlighted == '1') {
            let selected = this.gridApi.getSelectedNodes()
            _.each(selected, function (node) {
              let data = node.data
              if (data.account_id != account_id) {
                node.hightlight = null
                node.setSelected(false)
              } else {
                node.hightlight = '1'
                node.setSelected(true)
              }
            })    
          } else {
            event.node.setSelected(true)

            this.gridApi.forEachNode(function (node) {
              node.highlighted = null
            })

            event.node.highlighted = '1'
          }

          if (
            this.sdAccountClickEventAccId != account_id &&
            this.sdContactClickEventConId == null
          ) {
            this.sdAccountClickEventAccId = account_id
            this.$emit('showContactsWithAccountID', account_id)
          } else {
            this.sdAccountClickEventAccId = null
            this.$emit('showContactsWithAccountID', null)

            event.node.setSelected(false)
            event.node.highlighted = null

          }
        }





        if (
          event.context == 'SDQCContact' || event.context == 'ContactDataSourceForClientView'
        ) {


        

          
          let contact_id = event.data.new_contact_id



          if(contact_id == undefined){
            contact_id = event.data.contact_id
          }

          if (event.node.highlighted == '1') {
            let selected = this.gridApi.getSelectedNodes()
            _.each(selected, function (node) {
              let data = node.data
              if (data.contact_id != contact_id) {
                node.hightlight = null
                node.setSelected(false)
              } else {
                node.hightlight = '1'
                node.setSelected(true)
              }
            })

        
          } else {
            event.node.setSelected(true)

            this.gridApi.forEachNode(function (node) {
              node.highlighted = null
            })

            event.node.highlighted = '1'
          }




          if (
            this.sdContactClickEventConId != contact_id &&
            this.sdAccountClickEventAccId == null
          ) {
            let account_id = event.data.account_id
            this.sdContactClickEventConId = contact_id
            this.$emit('showContactsFieldsWithContactID', contact_id , account_id)
          } else {
            this.sdContactClickEventConId = null
            this.$emit('showContactsFieldsWithContactID', null , null)
              

            event.node.setSelected(false)
            event.node.highlighted = null
          }
        }

        if (event.colDef.field == 'audit_trial') {
          this.showSalesDeveloperAuditTrial(event)
        }

        if (event.colDef.field == 'client-user-stats') {
          this.$router.push(
            '/client-dashboard/statistics/' +
              event.data.campaign_id +
              '/' +
              event.data.user_id
          )
        }

        if (event.colDef.field == 'client-user-gantt') {
          // console.log(event.data)
          this.$router.push(
            '/campaigns/view-gantt-steps/' +
              event.data.campaign_id +
              '/' +
              event.data.user_id
          )
        }

        if (event.colDef.field == 'client-user-live') {
          this.showClientUserLive(event.data)
          // alert("client-user-live")
        }

        if (event.colDef.field == 'client-user-insights') {
          this.showClientUserInsights(event.data)
        }

        if (event.colDef.field == 'contact-campaign-status') {
          this.showCampaignStatusPopup(event.data)
        }

        if (event.colDef.field == 'new-selected_accounts-for-campaign') {
          this.showCampaignStatusPopup(event.data)
        }
      }
    },
    onCellValueChanged (event) {
      // console.log(
      //   "onCellValueChanged: " + event.oldValue + " to " + event.newValue
      // );
    },
    onCellDoubleClicked (event) {
      // this.showCampaignStatusPopup(event.data);
    },
    onCellContextMenu (event) {
      // console.log(
      //   "onCellContextMenu: " + event.rowIndex + " " + event.colDef.field
      // );
    },
    onCellFocused (event) {


      // console.log(
      //   "onCellFocused: (" + event.rowIndex + "," + event.colIndex + ")"
      // );
    },
    // taking out, as when we 'select all', it prints to much to the console!!
    // eslint-disable-next-line
    onRowSelected(event) {
      
     let self = this

     if (event.context != 'enrichAccountContactsGrid') {

    if (event.node.selected == false) {
     
      self.all_selected_rows = self.all_selected_rows.filter(function (item) {
        return item.contact_id !== event.data.contact_id
    })

  }
}else{
  if (event.node.selected == false) {
     
      self.all_selected_rows = self.all_selected_rows.filter(function (item) {
        return item.account_id !== event.data.account_id
    })

  }
}





 

    console.log("ALL sdsfdfsdfsdf SELECTED ROWS" , self.all_selected_rows)



      // console.log(this.gridOptions.api.getDisplayedRowCount());
      // console.log(this.gridOptions.api.getSelectedRows())
      // this.gridOptions.api.selectAll()
    },
    sendSelectionToActualPage () {
      this.$emit('sendSelectionToActualPage', this.all_selected_rows)
    },
    onSelectionChanged (params) {

let self = this
if (params.context == 'enrichAccountContactsGrid') {

  self.gridApi.getRenderedNodes().map(function (row) {
    if (row.selected == true) {
      if (self.all_selected_rows.includes(row.data) == false){
      self.all_selected_rows.push(row.data)
      }
    }
  })

  self.all_selected_rows = self.all_selected_rows.filter(function (item, pos) {
    return self.all_selected_rows.indexOf(item) == pos;
  })




}else if (params.context == 'AssociateContactToSelectedAccount') {
  self.all_selected_rows = []
    self.gridApi.getRenderedNodes().map(function (row) {
    if (row.selected == true) {
      self.all_selected_rows.push(row.data)
    }
    
  })


}
else if (params.context == 'AddNewAccountsWithAdvancedCriteria') {



self.gridApi.getRenderedNodes().map(function (row) {
  if (row.selected == true) {
    if (self.all_selected_rows.includes(row.data) == false){
    self.all_selected_rows.push(row.data)
    }
  }
})



self.all_selected_rows = self.all_selected_rows.filter(function (item, pos) {
  return self.all_selected_rows.indexOf(item) == pos;
})




}

else{
  self.all_selected_rows = self.gridApi.getSelectedNodes()
}




this.sendSelectionToActualPage()
},
//     onSelectionChanged (params) {

// let self = this

// self.all_selected_rows = []
// if (params.context == 'AddNewAccountsWithAdvancedCriteria' || params.context == 'AssociateContactToSelectedAccount' || params.context == 'enrichAccountContactsGrid' || params.context != 'individaullySelectedGrid') {
//     self.gridApi.getRenderedNodes().map(function (row) {
//     if (row.selected == true) {
//       self.all_selected_rows.push(row.data)
//     }
//   })

// }else{
//   self.all_selected_rows = self.gridApi.getSelectedNodes()
// }









// this.sendSelectionToActualPage()
// },
    insertAccountToCampaign () {
      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.all_selected_rows = this.all_selected_rows
 
      let new_selected_account_id = ''
      this.all_selected_rows.map(function (row) {
        new_selected_account_id += "'" + row.account_id + "',"
      })
      if (new_selected_account_id != ''){
        new_selected_account_id = new_selected_account_id.replace(/,\s*$/, "");
      }



      localStorage.setItem("new_selected_account_ids_to_campaign", new_selected_account_id);



      axios
        .post(
          this.$base_url +
            '/api/accounts/insert_individual_accounts_to_campaign',
          data
        )
        .then(response => {
          self.all_selected_rows = []
          if (this.$route.name == 'add-new-accounts-contacts-to-campaign') {
            this.$vs.notify({
              color: 'success',
              title: 'Account Added',
              text: 'The account has been added to the campaign successfully. Please associate to be shown on the campaigns list.'
            })
            this.$router
              .push(
                '/accounts/new_selected_accounts/' +
                  this.$route.params.campaignId
              )
              .catch(() => {})
          } else {
            this.$router.push(
              '/accounts/existing_selected_accounts/' +
                this.$route.params.campaignId
            )
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    getCampaignAccountsTotalRows() {
      

      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId

      axios
        .post(
          this.$base_url +
            '/api/accounts/get_campaign_accounts_total_rows',
          data
        )
        .then(response => {
          self.table_total_rows = response.data


          
          self.gridApi.setGridOption('paginationPageSize', self.table_total_rows)
        
        })
        .catch(error => {
          console.log(error)
        })
    },

    getCampaignContactsTotalRows() {
      

      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.account_ids = this.all_selected_rows




      axios
        .post(
          this.$base_url +
            '/api/accounts/get_campaign_contacts_total_rows',
          data
        )
        .then(response => {
          self.table_total_rows = response.data


          
          self.gridApi.setGridOption('paginationPageSize', self.table_total_rows)
        
        })
        .catch(error => {
          console.log(error)
        })
    },

    getTotalRowsOfTable (table_name) {
      let self = this
      let data = {}
      data.table_name = table_name
      axios
        .post(
          this.$base_url +
            '/api/accounts/get_total_rows_of_table',
          data
        )
        .then(response => {
          self.table_total_rows = response.data
          self.gridApi.setGridOption('paginationPageSize', self.table_total_rows)
        
        })
        .catch(error => {
          console.log(error)
        })
    },
    acceptMultipleContactstoAccountForCampaign () {
      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.all_selected_rows = this.all_selected_rows
      data.selected_account_id = this.selected_account.uuid


      // console.log(this.selected_account.action_type)
      axios
        .post(
          this.$base_url +
            '/api/contacts/insert_multiple_accounts_for_campaign',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.all_selected_rows = []
            self.gridApi.deselectAll()
            if (
              this.selected_account.action_type ==
              'associateContactToSelectedAccountPopup'
            ) {
              self.$emit(
                'associateContactToSelectedAccountPopup',
                self.selected_account
              )
            } else {
              self.$emit('showContactsPopUp', self.selected_account)
            }

            self.refreshAccountSelectionGrid()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    insertContactstoExistingAccountForCampaign () {
      let self = this

      let all_selected_contact_ids = []


      let data = {}
      data.campaignId = this.$route.params.campaignId

this.all_selected_rows.map(function (row) {
        all_selected_contact_ids.push(row.contact_id)
      })

      data.all_selected_rows = all_selected_contact_ids
      


      data.selected_account_id = this.selected_account.uuid
      axios
        .post(
          this.$base_url +
            '/api/contacts/insert_contacts_to_existing_accounts_for_campaign',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.all_selected_rows = []
            self.gridApi.deselectAll()
            if (
              this.selected_account.action_type ==
              'associateContactToSelectedAccountPopup'
            ) {
              self.$emit(
                'associateContactToSelectedAccountPopup',
                self.selected_account
              )
            } else {
              self.$emit('showContactsPopUp', self.selected_account)
            }

            self.refreshAccountSelectionGrid()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    insertAccountContactsWithCriteria () {
      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.all_selected_rows = this.all_selected_rows


   


      axios
        .post(
          this.$base_url +
            '/api/accounts/insert_accounts_contacts_to_campaign_with_criteria',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.all_selected_rows = []
            this.gridApi.deselectAll()
            this.gridApi.refreshServerSide({purge : true})

            self.$router.go(0);

          }
        })
        .catch(error => {
          console.log(error)
        })
      //  alert('Insert account contacts')
    },
    onFilterModified (event) {
      // console.log(event , "onFilterModified");
    

      
    },
    onFilterApply (event) {
      this.onSDAccountFilterModified(event)


      this.gridApi.deselectAll()

      let self = this

      self.all_selected_rows.forEach(function (row) {
        self.gridApi.forEachNode(function (node) {
          if (typeof (node.data) != 'undefined'){

           if (typeof(node.data.contact_id) != 'undefined' ){

            if (node.data.contact_id == row.contact_id) {
            node.setSelected(true)
          }

           }
           else{

            if (node.data.account_id == row.account_id) {
            node.setSelected(true)
          }

           }

          }

          
        })

        
      })
      



    },
    onSDAccountFilterModified (event) {
      this.$emit('onSDQCAccountFilterModified', event)
    },
    // eslint-disable-next-line
    onVirtualRowRemoved(event) {
      // because this event gets fired LOTS of times, we don't print it to the
      // console. if you want to see it, just uncomment out this line
      // console.log('onVirtualRowRemoved: ' + event.rowIndex);
    },
    onRowClicked (event) {
      let event_data = event.data
      this.goToReviewQualityControlPage(event_data)
      // console.log("onRossswClicked: " + event_data.campaign_id);
    },
    onQuickFilterChanged (event) {
      this.gridOptions.api.setQuickFilter(event.target.value)
    },
    // here we use one generic event to handle all the column type events.
    // the method just prints the event name
    onColumnEvent (event) {
      // console.log("onColumnEvent: " + event);
    },
    getRowId() {
      return Math.random().toString();
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    // console.log(this.$refs)
    if (this.$vs.rtl) {
      const header = this.$refs.enrichAccountGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left =
        '-' + String(Number(header.style.transform.slice(11, -3)) + 9) + 'px'
    }
  },
  beforeMount () {
    this.rowModelType = 'serverSide'
    this.serverSideStoreType = 'partial'
    this.cacheBlockSize = 10
    this.paginationPageSize = 10
    this.paginationPageSizeSelector = [10, 20, 50, 100];



    // this.context = {
    //   componentParent: this
    // }
  },
  created () {

    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            headerName: 'Head Office Address 1',
            field: 'head_office_address_1'
          },
          {
            headerName: 'Head Office Address 2',
            field: 'head_office_address_2'
          },
          {
            headerName: 'Head Office Address 3',
            field: 'head_office_address_3'
          },
          {
            headerName: 'Head Office City',
            field: 'head_office_city'
          },
          {
            headerName: 'Head Office County',
            field: 'head_office_county'
          },
          {
            headerName: 'Head Office Country',
            field: 'head_office_country'
          },

          {
            headerName: 'Head Office Postcode',
            field: 'head_office_postcode'
          },
          {
            headerName: 'Registered Office Address 1',
            field: 'head_office_address_1'
          },
          {
            headerName: 'Registered Office Address 2',
            field: 'head_office_address_2'
          },
          {
            headerName: 'Registered Office Address 3',
            field: 'head_office_address_3'
          },
          {
            headerName: 'Registered Office City',
            field: 'head_office_city'
          },
          {
            headerName: 'Registered Office County',
            field: 'head_office_county'
          },
          {
            headerName: 'Registered Office Country',
            field: 'head_office_country'
          },
          {
            headerName: 'Registered Office Postcode',
            field: 'head_office_postcode'
          }
        ]
      },
      getDetailRowData: params => {
        // console.log("fsdfsdf", params.data)
        params.successCallback([params.data])
      }
    }

    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }
  }
}
</script>

<style lang="scss">

</style>
